export default __webpack_public_path__ + "static/phone_w.18e5d0d81638b13ed8ef3cbc457b65b7.png";